import { Game } from "@/models/game"
import { EnergySource } from '@/models/energy-source'

export default {
    aiPlayers(state: Game) {
        return state.aiPlayers
    },
    energySources(state: Game) {
        return state.energySources
    },
    event(state: Game) {
        let events = null
        if (state.rounds != null) {
            events = state.rounds[state.activeRound - 1].events
        }
        return events ? events[0] : null
    },
    activeRound(state: Game) {
        return state.activeRound
    },
    playerEnergy(state: Game) {
        return state.playerEnergy
    },
    isGameOver(state: Game) {
        if (state.rounds != null) {
            return state.playerLost || state.gameOver
        }
        return false
    },
    playerWon(state: Game) {
        return state.gameOver && !state.playerLost ? true : false
    },
    hasSource(state: Game) {
        // hacky solution for vuejs to have reactivity for Map types.
        // https://github.com/vuejs/vue/issues/2410
        state.inventory.inventoryChangeNum
        // WTF???
        const names: string[] = []
        Array.from(state.inventory.energySources.keys()).forEach((source: EnergySource) => names.push(source.name))
        return (element: string) => {
            const thesource = Array.from(state.inventory.energySources.keys()).find((es: EnergySource) => es.name === element)
            let foo = null
            if (thesource != null) {
                const test = state.inventory.energySources.get(thesource)
                if (test != null) {
                    foo = test.find((thing) => thing.isBuilt === true)
                }
            }
            return names.find((source) => source === element) !== undefined ? foo : false
        }
    }
}